import { NavLink } from "react-router-dom";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faLocationDot, faEnvelope, faPhone} from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
    return (
        <footer style={{ backgroundColor: "var(--brand-color)" }}>
            <div className="container m-0 m-lg-auto p-3">
                <div className="row">
                    {/* About */}
                    <div className="col-lg-3 text-light">
                        <h5>About Our Company</h5>
                        <p className="text-justify">
                            Established in 2017 and based in Moshi, Pune, we are a leading supplier,
                            importer, and service provider of standard and special fasteners and pneumatic tools.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div className="col-lg-2 mb-3 mb-lg-0 text-light links">
                        <h5>Quick Links</h5>
                        <ul aria-label="Quick Links">
                            <li className="mb-0"><NavLink to="/" className="ms-3">Home</NavLink></li>
                            <li className="mb-0"><NavLink to="/about" className="ms-3">About</NavLink></li>
                            <li className="mb-0"><NavLink to="/gallery" className="ms-3">Gallery</NavLink></li>
                            <li className="mb-0"><NavLink to="/qualityAssurance" className="ms-3">Quality Assurance</NavLink></li>
                            <li className="mb-0"><NavLink to="/contact" className="ms-3">Contact</NavLink></li>
                        </ul>
                    </div>

                    {/* Products */}
                    <div className="col-lg-3 mb-3 mb-lg-0 text-light links">
                        <h5>Our Products</h5>
                        <ul aria-label="Our Products">
                            <li className="mb-0"><NavLink to="/electricalAutomotive" className="ms-3">Electrical & Automotive</NavLink></li>
                            <li className="mb-0"><NavLink to="/metalFabricationAssembly" className="ms-3">Metal Fabrication & Assembly</NavLink></li>
                            <li className="mb-0"><NavLink to="/automatedMachinery" className="ms-3">Automated Machinery</NavLink></li>
                            <li className="mb-0"><NavLink to="/consumerTechPlastics" className="ms-3">Consumer Tech & Plastics</NavLink></li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div className="col-lg-4 text-light">
                        <h5 className="mb-2">Contact Us</h5>

                        <div className="d-flex align-items-start">
                            <FontAwesomeIcon icon={faLocationDot} className="me-3 mt-1" />
                            <span>
                                D-704, Silver-9 CHS, Opp Nageshwar Petrol Pump, Behind D-Mart,
                                Borhadewadi, Moshi, Pune-412105
                            </span>
                        </div>

                        <div className="d-flex align-items-center">
                            <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                            <a href="mailto:info@vibhaenterprises.co.in" className="text-light text-decoration-none">
                                info@vibhaenterprises.co.in
                            </a>
                        </div>

                        <div className="d-flex align-items-center">
                            <FontAwesomeIcon icon={faPhone} className="me-2" />
                            <a href="tel:9356579987" className="text-light text-decoration-none">
                                +919356579987
                            </a>
                        </div>
                    </div>
                </div>

                <hr style={{ borderColor: "white" }} />
                <p className="text-center text-light mb-0">
                    Copyrights © {new Date().getFullYear()} Vibha Enterprises. All Rights Reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
